import React from 'react'
import styled from 'styled-components/macro'
import { Hidden } from '@resultadosdigitais/tangram-components'
import { useHostContext } from '@resultadosdigitais/front-hub/react'
import { useTranslation } from 'react-i18next'

const ImgBox = styled.a`
  flex: 1;
  background-image: url(${props => props.url});
  background-size: cover;
  background-position: center;
`

function SideBanner({ isLoginForm }) {
  const { i18n } = useTranslation()
  const contextData = useHostContext()
  const CURRENT_LANGUAGE = i18n.language
  const CURRENT_BANNER = contextData?.data?.banner[CURRENT_LANGUAGE]

  function showCurrentBanner(banner) {
    if (CURRENT_BANNER && CURRENT_BANNER?.show) return CURRENT_BANNER
  }

  const bannerData = showCurrentBanner(CURRENT_BANNER)

  const shouldShowBanner = () => {
    if (isLoginForm & bannerData?.show) return true
  }

  return (
    <>
      {shouldShowBanner() && (
        <Hidden only={[Hidden.viewports.smallMobile, Hidden.viewports.mobile, Hidden.viewports.tablet]}>
          <ImgBox url={bannerData.image.url} title={bannerData.image.title} alt={bannerData.image.alt} href={bannerData.image.link} target="_blank" />
        </Hidden>
      )}
    </>
  )
}

export default SideBanner
